// extracted by mini-css-extract-plugin
export default {"gridContent":"CategoryData_gridContent__PXq1c","gridWrapper":"CategoryData_gridWrapper__U0-YE"};